import { api } from './operations.generated';
import { getLogger } from '../../libs/logger';

const logger = getLogger('userSettingsApi');

/**
 * Enhanced userSettings API with cache update logic.
 * Updates the GetUserSettings query cache after a successful mutation
 * so the UI reflects changes immediately without a refetch.
 */
export const userSettingsApi = api.enhanceEndpoints({
  endpoints: {
    UpdateUserSettings: {
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          dispatch(
            api.util.updateQueryData('GetUserSettings', undefined, (draft) => {
              if (draft.userSettings) {
                draft.userSettings.isSelfPreviewEnabled =
                  data.updateUserSettings.isSelfPreviewEnabled;
              } else {
                draft.userSettings = data.updateUserSettings;
              }
            }),
          );
        } catch (error) {
          logger.warn('Failed to update user settings', {
            method: 'onQueryStarted',
            error,
          });
        }
      },
    },
  },
});

export const { useUpdateUserSettingsMutation } = userSettingsApi;
